import React, { ReactElement, ReactNode, useState } from "react";
import Head from "next/head";
import dynamic from "next/dynamic";

import Header from "@components/websitebuilderselect/header";
import { getCookie, setCookie } from "cookies-next";
import { useModal } from "@hooks/useModalContext";
import Schema from "@components/scripts/schema";
import { useDomainContext } from "@hooks/useDomainContext";
import Mobile from "@components/shared/blogPost/sideWidget/mobile";
const Footer = dynamic(() => import("@components/websitebuilderselect/footer"));
const CloseIcon = dynamic(() => import("@components/svg/closeIcon"));
const Popup = dynamic(() => import("@components/websitebuilderselect/popup"));
const Modal = dynamic(() => import("@components/shared/modal"));
export default function WebsiteBuilderSelectWrapper({
    children,
    useSecondaryLogo,
}: {
    children: ReactNode;
    useSecondaryLogo?: boolean;
}): ReactElement {
    const { modal, closeModal } = useModal();
    const [vpnModalActive, setVpnModalActive] = useState(false);
    const modalActive = vpnModalActive;
    const { active: modalActiveBlogPost } = modal;
    const handleClose = () => {
        closeModal();
    };
    const { domainPopup } = useDomainContext();

    const handleMouseLeave = () => {
        if (
            document.activeElement?.tagName === "INPUT" ||
            document.activeElement?.tagName === "SELECT"
        )
            return;

        if (!getCookie("popup-shown")) {
            setVpnModalActive(true);
            setCookie("popup-shown", "true");
        }
    };

    const handleModalClose = () => {
        setVpnModalActive(false);
    };

    return (
        <>
            <Head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link
                    rel="preconnect"
                    href="https://fonts.gstatic.com"
                    crossOrigin="true"
                />
                <link
                    href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700;800&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,900;1,800&display=swap"
                    rel="stylesheet"
                />

                <Schema
                    url="https://Websitebuilderselect.com"
                    name="Website Builder Select"
                />
            </Head>
            <div
                onMouseLeave={handleMouseLeave}
                style={{
                    fontFamily: `'Open Sans', sans-serif`,
                }}
            >
                <Header useSecondaryLogo={useSecondaryLogo} />
                <main className="max-w-7xl mx-auto block px-4vw lg:px-4">
                    {children}
                </main>
                <Footer />
                {domainPopup && (
                    <Modal
                        onClose={handleModalClose}
                        active={modalActive}
                        closeIcon={<CloseIcon />}
                        backdropClosable
                        modalClassName="h-90vh lg:h-500px rounded"
                        wrapperClassName="flex items-center"
                        modalStyles={{ fontFamily: `'Poppins', sans-serif` }}
                        bodyStyles={{ height: "100%" }}
                        width={900}
                    >
                        <Popup data={domainPopup} />
                    </Modal>
                )}
                <Modal
                    onClose={handleClose}
                    active={modalActiveBlogPost}
                    closeIcon={<CloseIcon />}
                    backdropClosable
                    modalStyles={{
                        display: "flex",
                        flexDirection: "column",
                        maxHeight: "80vh",
                    }}
                    modalClassName="h-[90vh] rounded"
                    bodyStyles={{ overflowY: "scroll" }}
                    width={900}
                    header="Contents"
                >
                    <Mobile />
                </Modal>
            </div>
        </>
    );
}
